import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import SocialMediaFeed from '../components/SocialMediaFeed';
import Footer from '../components/Footer';
import Chatbot from '../components/Chatbot';
import WhyChoose from '../components/WhyChoose';

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <Portfolio />
    <About />
    <WhyChoose />
    <Services />
    <Testimonials />
    <SocialMediaFeed />
    <Footer />
    <Chatbot />
  </>
);

export default HomePage;
